import { serialize } from '@/@core/libs/serialize/util'
import Http from '@/services/httpCommunity'

export const communityList = (
	params = {
		per_page: 10,
		page: 1,
		'filter[term]': '',
	},
) => Http.get(`/communities/fetch${serialize(params)}`)

export const communityShow = id => Http.get(`/communities/${id}/show`)

export const communityMembers = (id, params = {}) =>
	Http.get(`/communities/${id}/members${serialize(params)}`)

export const communityPosts = (id, params = {}) =>
	Http.get(`/communities/${id}/posts${serialize(params)}`)

export const communityThreads = (id, params = {}) =>
	Http.get(`/communities/${id}/threads${serialize(params)}`)

export const communityUpdate = (params = {}) =>
	Http.put(`/creator-mode/community/${params.url}`, params, { baseURL: 'locale' })

// Admin-only destroy — was previously reusing the non-admin creator-mode
// delete route (the same endpoint an end-user "creator" calls), which had no
// admin-specific guarantee behind it.
export const communityDestroy = params => Http.delete(`/communities/${params.id}`)

export const communityTransferOwnership = (communityId, memberId) =>
	Http.post(`/communities/${communityId}/members/${memberId}/transfer-ownership`)

export const communityDeletePost = (communityId, postId) =>
	Http.delete(`/communities/${communityId}/posts/${postId}`)

export const communityDeleteThread = (communityId, threadId) =>
	Http.delete(`/communities/${communityId}/threads/${threadId}`)

export const communityRemoveMember = (communityId, userId) =>
	Http.delete(`/communities/${communityId}/members/${userId}`)

export const communityUpdateMemberRole = (communityId, userId, role) =>
	Http.patch(`/communities/${communityId}/members/${userId}/role`, { role })

// Tier/verification actions — folded in from the old, unreachable-from-nav
// management.vue, which hardcoded the /en/ locale segment directly. These
// route through baseURL: 'locale' (the admin's currently selected locale)
// like communityUpdate/communityDestroy already do.
export const communityVerifyOfficial = communityId =>
	Http.post(`/communities/admin/verify-official/${communityId}`, {}, { baseURL: 'locale' })

export const communityRevokeOfficial = communityId =>
	Http.post(`/communities/admin/revoke-official/${communityId}`, {}, { baseURL: 'locale' })

export const communityTogglePremium = communityId =>
	Http.post(`/communities/admin/toggle-premium/${communityId}`, {}, { baseURL: 'locale' })

export const communityTogglePromoted = communityId =>
	Http.post(`/communities/admin/toggle-promoted/${communityId}`, {}, { baseURL: 'locale' })
